import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({ providedIn: 'root' })
export class DataService {
  private globalState: any = {
    policies: {},
    recentSearches: [],
    adviserCode: ''
  };

  private readonly dataSource = new BehaviorSubject<any>(null);
  data$ = this.dataSource.asObservable();

  set(key: string, value: any): void {
    this.globalState[key] = value;
  }

  get(key: string): any {
    return this.globalState[key];
  }

  /**
   * Triggers subscribed components to re-initialise their data object and UI the new GLOBAL policy data
   */
  updateData(newData: any) {
    this.dataSource.next(newData);
  }
}
